webpackJsonp([1],{

/***/ "/zvN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_debounce__ = __webpack_require__("HhAh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'gallery',
  data: function data() {
    return {
      doc: document.documentElement,
      fixed: false,
      animate: false,
      idx: 0
    };
  },

  props: {
    images: {
      type: [Array, Boolean],
      required: true
    },
    post: Object
  },
  computed: {
    active: function active() {
      return true;
    },
    title: function title() {
      if (!this.post) return;

      return this.post.title.rendered;
    },
    byline: function byline() {
      if (!this.post) return;

      var byline = this.post.acf.byline;

      if (!byline || !byline.length) return false;
      return byline;
    },
    galleryLength: function galleryLength() {
      return this.images && this.images.length;
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    init: function init(route) {
      var _this = this;

      var hash = route.hash;

      if (!hash) {
        hash = '#0';
        // return this.close()
      }
      var idx = parseInt(hash.replace('#', ''));
      this.idx = idx;

      if (!this.fixed) this.fixScroll();

      this.$nextTick(function () {
        _this.scrollPos();
      });
    },
    scrollPos: function scrollPos() {
      var current = this.$refs.container.getBoundingClientRect();
      var to = current.height * this.idx;
      if (this.animate) {
        scrollTo(this.$refs.container, to, 333);
        this.animate = false;
      } else {
        this.$refs.container.scrollTop = to;
      }
    },
    advance: function advance() {
      if (window.innerWidth < 833) return;
      var nextIdx = this.idx + 1;
      if (nextIdx === this.galleryLength) {
        nextIdx = 0;
      }
      this.animate = true;
      this.$router.replace('#' + nextIdx);
    },
    fixScroll: function fixScroll() {
      var _this2 = this;

      this.fixed = true;
      this.doc.classList.add('md-overflow-hidden');
      this.$nextTick(function () {
        _this2.listen = __WEBPACK_IMPORTED_MODULE_1_debounce___default()(_this2.bindScroll, 40);
        _this2.$refs.container.addEventListener('scroll', _this2.listen);
      });
    },
    releaseScroll: function releaseScroll() {
      this.fixed = false;
      this.doc.classList.remove('md-overflow-hidden');
      // this.$refs.container.removeEventListener('scroll', this.listen)
    },
    close: function close() {
      this.idx = 0;
      this.releaseScroll();
      this.$router.go(-1);
    },
    bindScroll: function bindScroll() {
      var current = this.$refs.container.getBoundingClientRect();
      var sp = this.$refs.container.scrollTop;
      this.idx = Math.round(sp / current.height);
    },
    listen: function listen() {}
  }, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapMutations */])({
    'zoomState': 'TOGGLE_ZOOM_STATE'
  })),
  watch: {
    $route: function $route(newVal) {
      this.init(newVal);
    }
  },
  mounted: function mounted() {
    this.init(this.$route);
  },
  destroyed: function destroyed() {
    this.releaseScroll();
  }
});

function scrollTo(element, to, duration) {
  var start = element.scrollTop;
  var change = to - start;
  var currentTime = 0;
  var increment = 20;

  var animateScroll = function animateScroll() {
    currentTime += increment;
    var val = easeInOutQuad(currentTime, start, change, duration);
    element.scrollTop = val;
    if (currentTime < duration) {
      setTimeout(animateScroll, increment);
    }
  };
  animateScroll();
}

// t = current time
// b = start value
// c = change in value
// d = duration
function easeInOutQuad(t, b, c, d) {
  t /= d / 2;
  if (t < 1) return c / 2 * t * t + b;
  t--;
  return -c / 2 * (t * (t - 2) - 1) + b;
}

/***/ }),

/***/ "288I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var submenuRoutes = ['commissions', 'commission', 'projects', 'project'];
var workRoutes = ['commissions', 'commission'];

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app-header',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    showSub: function showSub() {
      return submenuRoutes.indexOf(this.$route.name) > -1;
    },
    worksActive: function worksActive() {
      return workRoutes.indexOf(this.$route.name) > -1;
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapState */])(['title', 'description', 'ready', 'imgReady']))
});

/***/ }),

/***/ "42Hy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("DK6z");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4036ae02_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("rkwI");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4036ae02_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4Xaj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImageList_vue__ = __webpack_require__("RACY");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_401c6a6c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImageList_vue__ = __webpack_require__("Kyu+");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImageList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_401c6a6c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImageList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "AO5d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_partials_ImageList__ = __webpack_require__("4Xaj");
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'page',
  computed: {
    page: function page() {
      return this.$store.state.pages[this.$route.name];
    },
    content: function content() {
      return this.page.content && this.page.content.rendered;
    },
    isDesk: function isDesk() {
      return this.$route.name === 'desk';
    },
    deskList: function deskList() {
      return this.isDesk && this.page.acf.gallery;
    }
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    var slug = to.name.toLowerCase();
    __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].dispatch('getPage', slug).then(function () {
      next();
    });
  },

  components: { ImageList: __WEBPACK_IMPORTED_MODULE_1__components_partials_ImageList__["a" /* default */] }
});

/***/ }),

/***/ "ARWS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Gallery_vue__ = __webpack_require__("/zvN");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40cd925c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Gallery_vue__ = __webpack_require__("BUkl");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Gallery_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40cd925c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Gallery_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "BUkl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"relative"},[(_vm.active)?_c('div',{staticClass:"md-fixed top-0 right-0 bottom-0 left-0 bg-white z2",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }return _vm.advance($event)}}},[_c('ul',{ref:"container",staticClass:"list-reset m0 p0 md-full-height overflow-auto",on:{"click":_vm.advance}},_vm._l((_vm.images),function(image){return _c('li',{staticClass:"pb2 sm-pb3 md-pb0 flex justify-center items-center md-col-12 md-full-height"},[_c('responsive-image',{staticClass:"zoom-image pointer-arrow-right",attrs:{"image":image}})],1)}),0),_vm._v(" "),_c('div',{staticClass:"xs-hide sm-hide md-absolute sm-pl3 sm-pr2 sm-mt2 sm-pt2 top-0 left-0 line-height-1"},[_c('p',{staticClass:"pointer",on:{"click":_vm.close}},[_vm._v("⟨ back")])]),_vm._v(" "),(_vm.post)?_c('div',{staticClass:"xs-hide sm-hide md-absolute sm-px3 sm-my2 sm-py1 left-50 top-0 center h6 cursor-auto"},[_c('h3',{staticClass:"mt1 mb0"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.byline)?_c('p',{staticClass:"m0"},[_vm._v(_vm._s(_vm.byline))]):_vm._e()]):_vm._e()]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "DDYG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'responsive-image',
  props: {
    image: {
      type: Object,
      required: true
    },
    maxSize: Number
  },
  render: function render(createElement) {
    if (!this.image) {
      return createElement('span', {
        'class': 'px3 py2 bg-white rounded border border-silver'
      }, 'No image :(');
    }
    var srcset = [this.image.sizes.thumbnail, this.image.sizes.medium, this.image.sizes.medium_large, this.image.sizes.large, this.image.url];
    var src = srcset[3];
    if (this.maxSize >= 0) {
      src = srcset[this.maxSize];
    }
    return createElement('img', {
      'class': 'lazyload',
      ref: 'picture',
      attrs: {
        'data-src': src
      }
    });
  },

  watch: {
    image: function image(newVal) {
      if (newVal) {
        this.$refs.picture.classList.toggle('lazyloaded');
        this.$refs.picture.classList.toggle('lazyload');
      }
    }
  }
});

/***/ }),

/***/ "DK6z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_partials_GridItem__ = __webpack_require__("yk60");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'index',
  computed: {
    projects: function projects() {
      return this.$store.state[this.$route.name] || [];
    },
    nothing: function nothing() {
      return !this.projects.length;
    },
    home: function home() {
      return this.$store.state.pages['home'];
    },
    featured: function featured() {
      if (!this.home || !this.home.acf) return;
      var featured = this.home.acf.featured;

      return featured[Math.floor(Math.random() * featured.length)];
    },
    ready: function ready() {
      return this.$store.state.ready;
    },
    imgIsReady: function imgIsReady() {
      return this.$store.state.imgReady;
    }
  },
  methods: {
    makeReady: function makeReady() {
      this.$store.commit('READY');
    },
    imgReady: function imgReady() {
      this.$store.commit('IMG_IS_READY', true);
    }
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    var action = to.meta.action;

    if (!action) {
      action = 'getCommissions';
    }
    __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].dispatch(action).then(next);
  },
  mounted: function mounted() {
    if (!this.featured) {
      this.makeReady();
    } else {
      setTimeout(function () {
        // this.makeReady()
      }, 2300);
    }
  },

  components: { GridItem: __WEBPACK_IMPORTED_MODULE_1__components_partials_GridItem__["a" /* default */] }
});

/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state__ = __webpack_require__("lwq5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__("mUbh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutations__ = __webpack_require__("ukYY");






// import getters from './getters'

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: __WEBPACK_IMPORTED_MODULE_2__state__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_3__actions__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_4__mutations__["a" /* default */]
}));

/***/ }),

/***/ "Kw7b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_partials_ImageList__ = __webpack_require__("4Xaj");
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'project',
  computed: {
    post: function post() {
      var slug = this.$route.params.slug;
      var type = this.$route.meta.type;

      return this.$store.state[type].find(function (p) {
        return p.slug === slug;
      });
    },
    title: function title() {
      return this.post.title.rendered;
    },
    images: function images() {
      return this.post.acf && this.post.acf.gallery;
    },
    byline: function byline() {
      return this.post.acf && this.post.acf.byline;
    }
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    var slug = to.params.slug;
    var type = to.meta.type;

    __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].dispatch('getProject', { type: type, slug: slug }).then(function () {
      next();
    });
  },

  components: { ImageList: __WEBPACK_IMPORTED_MODULE_1__components_partials_ImageList__["a" /* default */] }
});

/***/ }),

/***/ "Kyu+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('gallery',{attrs:{"images":_vm.images,"post":_vm.post}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_679c2f90_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("ooiG");
function injectStyle (ssrContext) {
  __webpack_require__("aQ9t")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_679c2f90_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_partials_ResponsiveImage__ = __webpack_require__("DDYG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_analytics__ = __webpack_require__("AYPi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_analytics__);





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = "production" === 'production';


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('responsive-image', __WEBPACK_IMPORTED_MODULE_4__components_partials_ResponsiveImage__["a" /* default */]);


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_analytics___default.a, {
  id: "UA-110473545-1",
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */]
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  store: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */],
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  el: '#app',
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */]);
  }
});

/***/ }),

/***/ "RACY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_partials_Gallery__ = __webpack_require__("ARWS");
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'image-list',
  props: {
    images: {
      type: [Array, Boolean],
      required: true
    },
    post: Object
  },
  computed: {
    hideWhileActive: function hideWhileActive() {
      if (this.$store.state.imageZoomActive) {
        return 'sm-hide';
      }
      return;
    }
  },
  methods: {
    imageLink: function imageLink(idx) {
      return '#' + idx;
    }
  },
  components: { Gallery: __WEBPACK_IMPORTED_MODULE_0__components_partials_Gallery__["a" /* default */] }
});

/***/ }),

/***/ "RPTJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"md-flex"},[_c('div',{staticClass:"sidebar flex-none xs-hide sm-hide"}),_vm._v(" "),_c('div',{staticClass:"project-detail md-pl2"},[_c('div',{staticClass:"project-title black line-height-3 pt1 sm-pt0 md-right-align"},[_c('h1',{staticClass:"regular line-height-3 mt0",domProps:{"innerHTML":_vm._s(_vm.title)}}),_vm._v(" "),_c('p',{staticClass:"h6",domProps:{"innerHTML":_vm._s(_vm.byline)}})]),_vm._v(" "),_c('image-list',{staticClass:"m0",attrs:{"images":_vm.images,"post":_vm.post}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "S7T2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"grid-item sm-pr2"},[_c('router-link',{staticClass:"sm-flex hover-green pb2",attrs:{"to":_vm.postlink,"active-class":"nope"}},[_c('div',{staticClass:"thumb order-1"},[_c('responsive-image',{staticClass:"grid-item-img",attrs:{"image":_vm.thumbnail,"max-size":3}})],1),_vm._v(" "),_c('div',{staticClass:"sidebar project-title text-inherit line-height-3 pt1 sm-pt0 h6 self-start sticky top-h order-0 flex-none mb3 sm-mb0"},[_c('h3',{staticClass:"mt1 mb0"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.byline)?_c('p',{staticClass:"m0"},[_vm._v(_vm._s(_vm.byline))]):_vm._e()])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SyDD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppHeader_vue__ = __webpack_require__("288I");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6692e4a4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppHeader_vue__ = __webpack_require__("XToN");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6692e4a4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "XToN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"pt2 sm-px2 pb2 md-flex md-fixed sm-pt2 top-0 left-0 col-12 bg-white z1"},[_c('div',{staticClass:"sidebar"},[_c('router-link',{attrs:{"to":"/"}},[_c('h1',{staticClass:"inline-block m0 h4 regular py1 px2 sm-pt2",domProps:{"textContent":_vm._s(_vm.title)}})])],1),_vm._v(" "),_c('div',{staticClass:"sm-flex-auto ml1"},[_c('ul',{staticClass:"list-reset line-height-3 m0 fade-enter-active",class:{ 'fade-enter pe-none': !_vm.imgReady && !_vm.ready }},[_c('li',{staticClass:"inline-block"},[_c('router-link',{staticClass:"pl1 sm-py2 inline-block",class:{'router-link-active': _vm.showSub && _vm.ready},attrs:{"to":"/","exact":"","active-class":"nope"}},[_c('span',[_vm._v("Work")])])],1),_vm._v(" "),_c('li',{staticClass:"inline-block"},[_c('router-link',{staticClass:"pl1 sm-py2 inline-block",attrs:{"to":"/desk","exact":""}},[_c('span',[_vm._v("Journal")])])],1),_vm._v(" "),_c('li',{staticClass:"inline-block"},[_c('router-link',{staticClass:"pl1 sm-py2 inline-block",attrs:{"to":"/contact","exact":""}},[_c('span',[_vm._v("Contact")])])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Index__ = __webpack_require__("42Hy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Page__ = __webpack_require__("pMNZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Project__ = __webpack_require__("wa3q");







__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'commissions',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Index__["a" /* default */],
    meta: {
      action: 'getCommissions'
    }
  }, {
    path: '/projects',
    name: 'projects',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Index__["a" /* default */],
    meta: {
      action: 'getProjects'
    }
  }, {
    path: '/work/:slug',
    name: 'commission',
    component: __WEBPACK_IMPORTED_MODULE_5__components_Project__["a" /* default */],
    meta: {
      type: 'commissions'
    }
  }, {
    path: '/projects/:slug',
    name: 'project',
    component: __WEBPACK_IMPORTED_MODULE_5__components_Project__["a" /* default */],
    meta: {
      type: 'projects'
    }
  }, {
    path: '/desk',
    name: 'desk',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Page__["a" /* default */]
  }, {
    path: '/contact',
    name: 'contact',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Page__["a" /* default */]
  }],
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      setTimeout(function () {
        resolve(savedPosition || { x: 0, y: 0 });
      }, 40);
    });
  }
}));

/***/ }),

/***/ "aQ9t":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lwq5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var preloaded = window.hammick || {};

/* harmony default export */ __webpack_exports__["a"] = ({
  title: preloaded.title,
  description: preloaded.description,
  commissions: [],
  projects: [],
  pages: {
    contact: preloaded.contact || false,
    home: preloaded.home || false
  },
  imageZoomActive: false,
  ready: false,
  imgReady: false
});

/***/ }),

/***/ "mUbh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


var API_BASE = '/wp-json/wp/v2/';

/* harmony default export */ __webpack_exports__["a"] = ({
  getCommissions: function getCommissions(_ref) {
    var commit = _ref.commit,
        state = _ref.state;

    if (state.commissions.length > 1) return;

    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(apiUrl('posts'), { params: { per_page: 100 } }).then(function (_ref2) {
      var data = _ref2.data;

      commit('GET_COMMISSIONS', data);
    });
  },
  getProjects: function getProjects(_ref3) {
    var commit = _ref3.commit,
        state = _ref3.state;

    if (state.projects.length > 1) return;

    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(apiUrl('project'), { params: { per_page: 100 } }).then(function (_ref4) {
      var data = _ref4.data;

      commit('GET_PROJECTS', data);
    });
  },
  getProject: function getProject(_ref5, _ref6) {
    var commit = _ref5.commit,
        state = _ref5.state;
    var type = _ref6.type,
        slug = _ref6.slug;

    var postType = type === 'projects' ? 'project' : 'posts';
    if (state[type].length) return;

    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(apiUrl(postType), { params: { slug: slug } }).then(function (_ref7) {
      var data = _ref7.data;

      if (!data.length) throw new Error('404 Not Found');
      var post = data[0];
      commit('GET_PROJECT', { type: type, post: post });
    });
  },
  getPage: function getPage(_ref8, slug) {
    var commit = _ref8.commit,
        state = _ref8.state;

    if (state.pages[slug]) return;

    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/wp-json/oh/v1/pages/' + slug).then(function (_ref9) {
      var data = _ref9.data;

      commit('PAGE_LOADED', { slug: slug, data: data });
    });
  }
});

function apiUrl(endpoint) {
  return API_BASE + endpoint;
}

/***/ }),

/***/ "oUNd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"md-flex"},[_c('div',{staticClass:"sidebar flex-none xs-hide sm-hide"}),_vm._v(" "),_c('div',{staticClass:"flex-auto md-pl2"},[(_vm.isDesk)?_c('div',[_c('image-list',{staticClass:"m0 smaller",attrs:{"images":_vm.deskList}})],1):_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ooiG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"},on:{"click":_vm.makeReady}},[_c('app-header'),_vm._v(" "),_c('main',{staticClass:"main pt0 px2 sm-px3 md-px2"},[_c('router-view')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pMNZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Page_vue__ = __webpack_require__("AO5d");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d303de4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Page_vue__ = __webpack_require__("oUNd");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Page_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d303de4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Page_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qdZk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'grid-item',
  props: {
    post: {
      type: Object,
      required: true
    }
  },
  computed: {
    postlink: function postlink() {
      return this.post.link.replace(window.location.origin, '');
    },
    thumbnail: function thumbnail() {
      return this.post.acf.thumbnail || this.post.acf.gallery[0];
    },
    title: function title() {
      return this.post.title.rendered;
    },
    byline: function byline() {
      var byline = this.post.acf.byline;

      if (!byline || !byline.length) return false;
      return byline;
    }
  }
});

/***/ }),

/***/ "rkwI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"relative"},[_c('transition',{attrs:{"name":"fade"}},[(!_vm.ready)?_c('div',{staticClass:"absolute top-0 left-0 col-12 h-12 bg-white z1"},[_c('div',{staticClass:"md-flex"},[_c('div',{staticClass:"sidebar flex-none xs-hide sm-hide"}),_vm._v(" "),_c('div',{staticClass:"flex-auto md-pl2 larger sm-pr2 pointer"},[_c('responsive-image',{staticClass:"grid-item-img",attrs:{"image":_vm.featured,"max-size":4},nativeOn:{"lazybeforeunveil":function($event){return _vm.imgReady($event)}}})],1)])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"md-pl2 fade-enter-active",class:{ 'fade-enter': !_vm.ready }},[_c('ul',{staticClass:"list-reset m0 larger"},_vm._l((_vm.projects),function(project){return _c('grid-item',{key:project.id,attrs:{"post":project}})}),1),_vm._v(" "),(_vm.nothing)?_c('p',[_vm._v("No projects")]):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ukYY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  GET_COMMISSIONS: function GET_COMMISSIONS(state, data) {
    state.commissions = data;
  },
  GET_PROJECTS: function GET_PROJECTS(state, data) {
    state.projects = data;
  },
  GET_PROJECT: function GET_PROJECT(state, _ref) {
    var type = _ref.type,
        post = _ref.post;

    state[type].push(post);
  },
  PAGE_LOADED: function PAGE_LOADED(state, _ref2) {
    var slug = _ref2.slug,
        data = _ref2.data;

    state.pages[slug] = data;
  },
  TOGGLE_ZOOM_STATE: function TOGGLE_ZOOM_STATE(state, newVal) {
    state.imageZoomActive = newVal;
  },
  READY: function READY(state) {
    state.ready = true;
  },
  IMG_IS_READY: function IMG_IS_READY(state, val) {
    state.imgReady = val;
  }
});

/***/ }),

/***/ "wa3q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Project_vue__ = __webpack_require__("Kw7b");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5996d1c2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Project_vue__ = __webpack_require__("RPTJ");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Project_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5996d1c2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Project_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_partials_AppHeader__ = __webpack_require__("SyDD");
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  methods: {
    makeReady: function makeReady() {
      this.$store.commit('READY');
    }
  },
  mounted: function mounted() {
    if (window.location.pathname !== '/') {
      this.makeReady();
    }
  },

  components: { AppHeader: __WEBPACK_IMPORTED_MODULE_0__components_partials_AppHeader__["a" /* default */] }
});

/***/ }),

/***/ "yk60":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GridItem_vue__ = __webpack_require__("qdZk");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8c1dbadc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GridItem_vue__ = __webpack_require__("S7T2");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GridItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8c1dbadc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GridItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.062f741f0014896bb725.js